import { render, staticRenderFns } from "./ActionsCollection.vue?vue&type=template&id=00c13d8e&"
import script from "./ActionsCollection.vue?vue&type=script&lang=js&"
export * from "./ActionsCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports